const MS_PER_DAY = 1000 * 60 * 60 * 24;

export const getWarrantyDaysRemaining = ({ end, now }: { end: string; now: Date }): number =>
    Math.ceil((new Date(end).getTime() - now.getTime()) / MS_PER_DAY);
